import React, { Component } from "react";
import "../App.css";
import mindfull from "../images/mindful.png";

class AboutMindfullness extends Component {
  render() {
    return (
      <>
        <section className="about-wrapper">
          <h1>What Mindfulness can do for you</h1>
          <p>
            According  to psychological studies mindfulness helps to improve every area of life. Increasing your
            capacity for mindfulness supports your ability to manage stress and have a overall life balance.
            Being mindful gives you the ability to be present in moment and have gratitude for things that occur in your life.
            <br />
            <br />
            By focusing on the present, many people who practice
            mindfulness find that they are less likely to get caught up in
            worries about the future or regrets over the past, are less
            preoccupied with concerns about success and self-esteem, and are
            better able to form deep connections with others.
          </p>
          <img src={mindfull} />
        </section>
      </>
    );
  }
}

export default AboutMindfullness;
